import FormattedMessage from 'I18n/components/FormattedMessage';
import { AlertDanger, Body, Heading, LayoutSpaceVertical } from 'breeze-intelligence-kit';
import { UsageUpgradeButton } from './UsageUpgradeButton';
import { useCreditCheck } from 'policy-lib';
import { useEnrichmentCredits } from '../EnrichmentCreditsProvider';
import { useModalBulk } from '../ModalBulk/useModalBulk';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UsageMessage = ({
  canUpgrade,
  resetDays
}) => {
  if (canUpgrade) {
    return /*#__PURE__*/_jsxs(Body, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "hubSpotCredits.upgradeCreditsAlert.usedIncludedCredits"
      }), ' ', /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hubSpotCredits.upgradeCreditsAlert.restored",
        options: {
          count: resetDays
        }
      }), ' ', /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hubSpotCredits.upgradeCreditsAlert.needItSooner"
      }), ' ', /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hubSpotCredits.upgradeCreditsAlert.purchaseCredits"
      })]
    });
  }
  return /*#__PURE__*/_jsxs(Body, {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "hubSpotCredits.upgradeCreditsAlert.usedIncludedCredits"
    }), ' ', /*#__PURE__*/_jsx(FormattedMessage, {
      message: "hubSpotCredits.upgradeCreditsAlert.restored",
      options: {
        count: resetDays
      }
    }), ' ', /*#__PURE__*/_jsx(FormattedMessage, {
      message: "hubSpotCredits.upgradeCreditsAlert.needItSooner"
    }), ' ', /*#__PURE__*/_jsx(FormattedMessage, {
      message: "hubSpotCredits.upgradeCreditsAlert.askAdmin"
    })]
  });
};
export const UsageAlert = ({
  action,
  numberOfOperations
}) => {
  const {
    canUpgrade,
    hasError: hasErrorCredits,
    isHubspotCredits,
    resetDays = 0
  } = useEnrichmentCredits();
  const {
    isOverageEnabled
  } = useModalBulk();
  const {
    hasError: hasErrorCreditCheck,
    isAuthorized,
    isLoading
  } = useCreditCheck({
    action,
    numberOfOperations
  });
  const hasError = hasErrorCredits || hasErrorCreditCheck;
  if (!isHubspotCredits || isAuthorized || isLoading || isOverageEnabled || hasError) {
    return null;
  }
  return /*#__PURE__*/_jsx(AlertDanger, {
    children: /*#__PURE__*/_jsxs(LayoutSpaceVertical, {
      gap: "space",
      children: [/*#__PURE__*/_jsxs(LayoutSpaceVertical, {
        gap: "space-xs",
        children: [/*#__PURE__*/_jsx(Heading, {
          as: "h6",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "hubSpotCredits.upgradeCreditsAlert.title"
          })
        }), /*#__PURE__*/_jsx(UsageMessage, {
          canUpgrade: canUpgrade,
          resetDays: resetDays
        })]
      }), /*#__PURE__*/_jsx(UsageUpgradeButton, {})]
    })
  });
};